<template>
  <div ref="modal" class="modal" tabindex="-1" role="dialog" id="modalcitoxconceptos">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-center">
            <b>Agregar Concepto al plan actual</b>
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body text-center">
          <p class="text-center">Solo se puede agregar un concepto cuando no existe en el plan de pagos actual.</p>
          <v-row>
            <v-col>
              <v-combobox v-model="concepto" :items="conceptos" label="Seleccione un concepto" outlined></v-combobox>
            </v-col>
          </v-row>
          <p class="text-center red--text">{{ msg }}</p>
        </div>
        <div class="modal-footer">
          <button
            @click="submit"
            :disabled="!concepto || !activo"
            type="button"
            class="btn btn-azul"
            style="color:white"
          >
            Aceptar
          </button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        msg: '',
        activo: true,
        conceptos: [],
        plan_pagos: [],
        concepto: null,
      };
    },
    watch: {
      concepto: function() {
        this.msg = '';
        if (!this.concepto) return;
        let existe = this.plan_pagos.find((e) => e.concepto_pago_id == this.concepto.id);
        if (existe) {
          this.activo = false;
          this.msg =
            'Este concepto ya existe en el plan de pagos actual, solo se puede asignar otro concepto cuando no existe ninguna cuota de ese concepto.';
        } else {
          this.activo = true;
        }
      },
    },
    components: {},
    methods: {
      open(conceptos, plan_pagos) {
        this.concepto = null;
        this.plan_pagos = plan_pagos;
        conceptos.forEach((e) => {
          e.text = e.nombre;
        });
        this.conceptos = conceptos;
        window.$('#modalcitoxconceptos').modal('show');
      },
      submit() {
        this.msg = '';
        if (this.concepto) {
          //window.console.log(this.concepto);
          let xnewplan = {
            id: -1994,
            monto: 0,
            total: 0,
            //saldo: -1,
            concepto_pago_id: this.concepto.id,
            concepto: this.concepto.nombre,
            concepto_pago: this.concepto.nombre,
            facturable: false,
            numero_cuota: 0,
            descuento: 0,
            fecha_pago: '',
            fecha_registro: '',
            reprogramado: false,
            bloqueado: false,
            saldo_regularizado: false,
            estado: true,
          };
          this.$emit('onselectconceptonew', xnewplan);
          window.$('#modalcitoxconceptos').modal('hide');
        }
      },
    },
  };
</script>
